import React, { useEffect, useState } from 'react';
import { Area, AreaChart, Tooltip, YAxis } from 'recharts';

const CustomTooltip = ({ active, payload, isPositive }: any) => {
    if (active && payload && payload?.length) {
        return (
            <div className="custom-tooltip">
                <p style={{ color: isPositive ? '#1AB759' : '#E93C3C' }} className="label">
                    {payload[0].value.toFixed(2) != '0.00' ? payload[0].value.toFixed(2) : payload[0].value}
                </p>
            </div>
        );
    }
    return null;
};

export function OnlinePriceTableChart(props: { data: number[] }) {
    const [mounted, setMounted] = useState(false);
    const ID = generateUniqueId();
    const [isPositive, setIsPositive] = useState<boolean>(
        props.data &&
            props.data?.length !== 0 &&
            props.data[props.data?.length - 1] - props.data[props.data?.length - 2] >= 0,
    );

    function generateUniqueId() {
        return 'id-' + Math.random().toString(36).substr(2, 9);
    }

    useEffect(() => {
        setMounted(true);
        if (props.data?.length > 0) {
            setIsPositive(props.data[props.data?.length - 1] - props.data[props.data?.length - 2] >= 0);
        }
    }, [props.data]);

    if (!mounted || !props.data || props.data?.length === 0 || !ID) return <></>;

    // Prepare data for the chart
    const chartData = props.data.map((item, index) => ({ item, index }));

    // Determine min and max for the Y-axis
    const minValue = Math.min(...props.data); // Adjust the minimum value as needed
    const maxValue = Math.max(...props.data); // Adjust the maximum value as needed

    return (
        <AreaChart width={80} height={32} data={chartData}>
            <defs>
                <linearGradient id={`colorUv${ID}`} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor={`${isPositive ? '#1AB759' : '#E93C3C'}`} stopOpacity={0.3} />
                    <stop offset="95%" stopColor={`${isPositive ? '#1AB759' : '#E93C3C'}`} stopOpacity={0} />
                </linearGradient>
            </defs>
            <Tooltip content={<CustomTooltip isPositive={isPositive} />} />
            <YAxis domain={[minValue, maxValue]} hide /> {/* Set the domain for the Y-axis */}
            <Area
                type="monotone"
                dataKey="item"
                stroke={`${isPositive ? '#1AB759' : '#E93C3C'}`}
                fillOpacity={1}
                fill={`url(#colorUv${ID})`}
            />
        </AreaChart>
    );
}
